import React, { useCallback, useEffect, useState } from 'react'
import './Themes.css'

import ClickItem from '../widgets/ClickItem';

export default function Themes() {

  const [theme, setTheme] = useState('nightsky');

  const updateColors = useCallback(() => {
    window.document.body.style.setProperty('background-color', `var(--${theme}-canvas-background-color)`);
    window.document.body.style.setProperty('--canvas-background-color', `var(--${theme}-canvas-background-color)`);
    window.document.body.style.setProperty('--canvas-color', `var(--${theme}-canvas-color)`);  
    window.document.body.style.setProperty('--dialog-1-bg-color', `var(--${theme}-dialog-1-bg-color)`);
    window.document.body.style.setProperty('--pane-1-background-color', `var(--${theme}-pane-1-background-color)`);  
    window.document.body.style.setProperty('--pane-2-background-color', `var(--${theme}-pane-2-background-color)`);  
    window.document.body.style.setProperty('--pane-3-background-color', `var(--${theme}-pane-3-background-color)`);  
    window.document.body.style.setProperty('--pane-4-background-color', `var(--${theme}-pane-4-background-color)`);  
    window.document.body.style.setProperty('--pane-2-color', `var(--${theme}-pane-2-color)`);      
    window.document.body.style.setProperty('--pane-2-title-background-color', `var(--${theme}-pane-2-title-background-color)`);      
    window.document.body.style.setProperty('--pane-2-title-color', `var(--${theme}-pane-2-title-color)`);  
    
    window.document.body.style.setProperty('--link-color', `var(--${theme}-link-color)`);  
    window.document.body.style.setProperty('--header-link-color', `var(--${theme}-header-link-color)`);
    window.document.body.style.setProperty('--link-hover-color', `var(--${theme}-link-hover-color)`);  
    window.document.body.style.setProperty('--link-hover-background-color', `var(--${theme}-link-hover-background-color)`);  
    window.document.body.style.setProperty('--link-active-color', `var(--${theme}-link-active-color)`);  
    window.document.body.style.setProperty('--link-active-hover-color', `var(--${theme}-link-active-hover-color)`);  
    window.document.body.style.setProperty('--link-active-border-color', `var(--${theme}-link-active-border-color)`);  
    window.document.body.style.setProperty('--link-active-background-color', `var(--${theme}-link-active-background-color)`);  
    window.document.body.style.setProperty('--button-hover-border-color', `var(--${theme}-button-hover-border-color)`);  
    window.document.body.style.setProperty('--button-hover-active-border-color', `var(--${theme}-button-hover-active-border-color)`);  
    window.document.body.style.setProperty('--config-crumbs-background-color', `var(--${theme}-config-crumbs-background-color)`);  
    window.document.body.style.setProperty('--pane-shadow-color', `var(--${theme}-pane-shadow-color)`);  
    window.document.body.style.setProperty('--path-crumbs-background-color', `var(--${theme}-path-crumbs-background-color)`);
    window.document.body.style.setProperty('--sdk-box-color', `var(--${theme}-sdk-box-color)`);
    window.document.body.style.setProperty('--sdk-box-background-color', `var(--${theme}-sdk-box-background-color)`);
  }, [theme]);

  const rollTheme = (e) => {
    setTheme(e.target.name);        
  }

  useEffect(() => {
    updateColors();
  },[theme, updateColors]);


  return (
    <div className='themes'>      
      <ClickItem key='ocean' name='ocean' onClick={rollTheme}>Ocean</ClickItem>
      <ClickItem key='nightsky' name='nightsky' onClick={rollTheme}>NightSky</ClickItem>
      <ClickItem key='morning' name='morning' onClick={rollTheme}>Morning</ClickItem>
      {/* <ClickItem key='noonian' name='noonian' onClick={rollTheme}>Noonian Sung</ClickItem> */}
      {/* <ClickItem key='eve' name='eve' onClick={rollTheme}>Eve</ClickItem>       */}
    </div>
  )
}
